let notifyComp = null
let confirmComp = null

export function setNotifyRef(ref) { notifyComp = ref }
export function setConfirmRef(ref) { confirmComp = ref }

export function useNotify() {
  const notify = {
    success: (msg) => notifyComp?.value?.addToast(msg, 'success'),
    error: (msg) => notifyComp?.value?.addToast(msg, 'error'),
    warning: (msg) => notifyComp?.value?.addToast(msg, 'warning'),
    info: (msg) => notifyComp?.value?.addToast(msg, 'info'),
  }

  const confirmDialog = (msg, options) => confirmComp?.value?.confirm(msg, options)

  return { notify, confirmDialog }
}
